/** @format */

import { CartItemAnalyticsV2 } from './cart-item-analytics-v2.interface';
import { ItemAttributes } from '../item-attributes.interface';
import { MyCustomizer } from '../my-customizer.interface';
import { Personalized } from '../personalized.interface';
import { ProcureMode } from '@shared/data-access/enums';
import { PDPTemplate, SelectedAddOn, Warranty } from '@shared/data-access/interfaces';

export interface CartItemV2 {
  addons?: SelectedAddOn[];
  analytics: CartItemAnalyticsV2;
  attributes: ItemAttributes;
  availableWarranties?: Warranty[];
  bopisStore?: string;
  description: string[];
  ecode: string;
  externalKey: string;
  images: string[];
  listPrice: number;
  manufacturer: string;
  myCustomizer: MyCustomizer;
  pdpTemplate: PDPTemplate;
  personalized: Personalized;
  preSale: boolean;
  procure: ProcureMode;
  quantity: number;
  sku: string;
  totalUnitPrice: string;
  unitPrice: number;
}
